<template>
  <div>
    <select
      :title="$t('message.novat')"
      :multiple="multiple"
      :class="className"
    >
      <option
        v-for="(item, index) in options"
        :key="index"
        :value="item.value"
      >
        {{ item.text }}
      </option>
    </select>
  </div>
</template>

<script>
import { uuid } from 'vue-uuid'
import _ from 'lodash'

export default {
  props: {
    value: {
      type: Array,
      default: () => ([]),
    },
    options: {
      type: Array,
      default: () => ([]),
    },
    multiple: {
      type: Boolean,
      default: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      className: uuid.v1(),
      selectedValues: [],
    }
  },

  watch: {
    disabled() {
      this.setDisable()
    },
    value() {
      const temp = _.cloneDeep(this.value)
      this.clearValues()
      this.$nextTick(() => {
        this.selectedValues = temp
        $(`.${this.className}`).selectpicker('val', temp)
      })
    },
  },

  created () {
    this.selectedValues = this.value
  },

  mounted() {
    const that = this

    $(`.${this.className}`).selectpicker()
    $(`.${this.className}`).on('changed.bs.select', function (e, clickedIndex, isSelected, previousValue) {
      if (clickedIndex == null && isSelected == null) {
        return
      }

      if (that.multiple === false) {
        clickedIndex -= 1
        that.clearValues()
      }

      const value = that.options[clickedIndex].value

      if (isSelected) {
        that.addValue(value)
      } else {
        that.removeValue(value)
      }

      that.emitData()

      $(`.${this.className}`).selectpicker('toggle')
    })

    this.$nextTick(() => {
      this.initValues()
      this.setDisable()
    })
  },

  methods: {
    addValue(value) {
      const getValueIndex = this.getValueIndex(value)
      if (getValueIndex === -1) {
        this.selectedValues.push(value)
      }
    },
    removeValue(value) {
      const getValueIndex = this.getValueIndex(value)
      if (getValueIndex !== -1) {
        this.selectedValues.splice(getValueIndex, 1)
      }
    },
    clearValues() {
      this.selectedValues = []
      $(`.${this.className}`).selectpicker('deselectAll')
    },
    getValueIndex(value) {
      return this.selectedValues.findIndex((v) => v === value)
    },
    emitData() {
      this.$emit('input', this.selectedValues)
      this.$emit('change', this.selectedValues)
    },
    setDisable() {
      if (this.disabled) {
        $(`.${this.className}`).prop('disabled', true)
        $(`.${this.className}`).selectpicker('refresh')
      } else {
        $(`.${this.className}`).prop('disabled', false)
        $(`.${this.className}`).selectpicker('refresh')
      }
    },
    initValues() {
      if (this.selectedValues.length) {
        $(`.${this.className}`).selectpicker('val', this.selectedValues)
      }
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/custom/MultipleSelect.vue